module.exports = __webpack_public_path__ + "static/icons/icon-point--green-21e5f36a5609d0ff875a89fe120a7167.svg";